import Home from "./pages/Home";
import SmartHome from "./pages/SmartHome";
import Login from "./pages/auth/Login";
import LoginRedirect from "./pages/auth/LoginRedirect";
import GetPasswordResetMail from "./pages/auth/GetPasswordResetMail";
import ResetPassword from "./pages/auth/ResetPassword";
import NotFound from "./pages/NotFound";
import ServerError from "./pages/ServerError";
import Profile from "./pages/auth/Profile";
import Logout from "./pages/auth/Logout";
import DefaultLayout from "./layouts/DefaultLayout"; // Importer DefaultLayout
import OTPVerification from "./pages/auth/OTPVerification";
import SellPoints from "./pages/stock/SellPoints";
import Entropots from "./pages/stock/Entropots";
import SellPointDetails from "./pages/stock/SellPointDetails";
import Category from "./pages/stock/Category";
import EditProduct from "./pages/stock/EditPoduct";
import ClientsOverview from "./pages/Clients/ClientsOverview";
import SimpleClients from "./pages/Clients/SimpleClients";
import ClientAddForm from "./pages/Clients/ClientAddForm";
import Professionals from "./pages/Clients/Professionals";
import ClientEditForm from "./pages/Clients/ClientEditForm";
import ProfessionalsAddForm from "./pages/Clients/ProfessionalsAddForm";
import ProfessionalsAddFacture from "./pages/Ventes/ProfessionalsAddFacture";
import ParticularAddFacture from "./pages/Ventes/ParticularAddFacture";
import ProfessionalsEditForm from "./pages/Clients/ProfessionnalsEditForms";
import Particulier from "./pages/Clients/Particulier";
import Professional from "./pages/Clients/Professionnal";
import Prospects from "./pages/Prospects/Prospects";
import ProspectDetails from "./pages/Prospects/ProspectDetails";
import ProspectEditForm from "./pages/Prospects/ProspectEditForm";
import ProspectAddForm from "./pages/Prospects/ProspectAddForm";
import { Facture } from "./pages/Ventes/Facture";
import FactureAddForm from "./pages/Ventes/FactureAddForm";
import FactureDetails from "./pages/Ventes/FactureDetails";
import Commercials from "./pages/Commerciaux/Commercials";
import AddCommercialForm from "./pages/Commerciaux/AddCommercialForm";
import EditCommercialForm from "./pages/Commerciaux/EditCommercialForm";
import CommercialDetails from "./pages/Commerciaux/CommercialDetails";
import StockOutflowApp from "./pages/stock/StockOutflowApp";
import StockEnterflowApp from "./pages/stock/StockEnterflowApp";
import Users from "./pages/Users/Users";
import UserAddForm from "./pages/Users/UserAddForm";
import UserEditForm from "./pages/Users/UserEditForm";
import UserDetails from "./pages/Users/UserDetails";
import Unauthorized from "./pages/Unauthorized";
import ProtectedRoute from "./components/ProtectedRoute";
import ConditionalRender from "./components/ConditionalRender";
import RoleBadge from "./components/RoleBadge";

export const AllElements = {
  Home,
  SmartHome,
  Login,
  LoginRedirect,
  GetPasswordResetMail,
  ResetPassword,
  NotFound,
  ServerError,
  Profile,
  Logout,
  DefaultLayout, // Exporter DefaultLayout ici
  OTPVerification,
  SellPoints,
  Entropots,
  SellPointDetails,
  Category,
  EditProduct,
  ClientsOverview,
  SimpleClients,
  ClientAddForm,
  Professionals,
  ClientEditForm,
  ProfessionalsAddForm,
  ParticularAddFacture,
  ProfessionalsAddFacture,
  ProfessionalsEditForm,
  Particulier,
  Professional,
  Prospects,
  ProspectDetails,
  ProspectEditForm,
  ProspectAddForm,
  Facture,
  FactureAddForm,
  FactureDetails,
  Commercials,
  AddCommercialForm,
  EditCommercialForm,
  CommercialDetails,
  StockOutflowApp,
  StockEnterflowApp,
  Users,
  UserAddForm,
  UserEditForm,
  UserDetails,
  Unauthorized,
  ProtectedRoute,
  ConditionalRender,
  RoleBadge,
};
